import { render, staticRenderFns } from "./tmaCreche.vue?vue&type=template&id=1999f14d&scoped=true&"
import script from "./tmaCreche.vue?vue&type=script&lang=js&"
export * from "./tmaCreche.vue?vue&type=script&lang=js&"
import style0 from "./tmaCreche.vue?vue&type=style&index=0&id=1999f14d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1999f14d",
  null
  
)

export default component.exports